import React, { FC, useContext, useEffect, useState } from "react"
import { I18nextProvider } from "react-i18next"

import translation from "../../../features/i18n/i18n"
import { AppUserData } from "../../../features/models/UserData"
import { IUserContext, userContext } from "../Providers"
import i18n from "./i18n"

interface IProps {
  children: React.ReactNode
}

const Provider: FC<IProps> = ({ children }) => {
  const { userData } = useContext<IUserContext<AppUserData>>(userContext)
  const [i18nInstance, setI18nInstance] = useState<any>(null)

  useEffect(() => {
    // Initialiser i18n en dehors du cycle de rendu
    const instance = i18n({ translation, userData })
    setI18nInstance(instance)
  }, [userData])

  // Ne rendre les enfants que lorsque i18n est initialisé
  if (!i18nInstance) {
    return null
  }

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>
}

export default Provider
